module.exports = __webpack_public_path__ + "img/small-monitor.a8310421.png";